function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import RichTextEditor from 'react-rte';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import ProductDetailsData from '../ProductDetails.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Checkbox from '../../common/form/Checkbox.react';
import Button from '../../common/Button.react';
var PpcProductDetails = function PpcProductDetails() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    app = _useParams.app,
    productID = _useParams.productID;
  var hasPermission = useHasPermission("edit-".concat(app, "-products"));
  var _useContext = useContext(ProductDetailsData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var title = state.title,
    archived = state.archived,
    description = state.description,
    descriptionLong = state.descriptionLong,
    specifications = state.specifications,
    usage = state.usage,
    isNYStateApproved = state.isNYStateApproved,
    construxCode = state.construxCode;
  var isValid = function isValid() {
    return true;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: (title === null || title === void 0 ? void 0 : title.length) > 0 ? title : 'Details'
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Description",
    required: true
  }), /*#__PURE__*/React.createElement(RichTextEditor, {
    value: description || RichTextEditor.createEmptyValue(),
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        description: val
      }));
    }
  }), app === 'construx' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Extended Description",
    required: true
  }), /*#__PURE__*/React.createElement(RichTextEditor, {
    value: descriptionLong || RichTextEditor.createEmptyValue(),
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        descriptionLong: val
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Specifications",
    required: true
  }), /*#__PURE__*/React.createElement(RichTextEditor, {
    value: specifications || RichTextEditor.createEmptyValue(),
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        specifications: val
      }));
    }
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Usage",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: usage,
    onChange: function onChange(e) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        usage: e.target.value
      }));
    }
  }), app === 'construx' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "NY State Approved"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: isNYStateApproved,
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        isNYStateApproved: val
      }));
    },
    label: "Yes"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Con-Strux Code"
  }), /*#__PURE__*/React.createElement(Input, {
    value: construxCode,
    onChange: function onChange(e) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        construxCode: e.target.value
      }));
    }
  })), !archived && hasPermission && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    disabled: !isValid(),
    onClick: function onClick() {
      dispatch({
        type: ppcActions.product,
        payload: {
          formData: {
            productID: productID,
            app: app,
            title: title,
            description: description === null || description === void 0 ? void 0 : description.toString('html'),
            descriptionLong: descriptionLong === null || descriptionLong === void 0 ? void 0 : descriptionLong.toString('html'),
            specifications: specifications === null || specifications === void 0 ? void 0 : specifications.toString('html'),
            usage: usage,
            isNYStateApproved: isNYStateApproved,
            construxCode: construxCode
          },
          method: 'put',
          route: 'details'
        }
      });
    }
  })))));
};
export default PpcProductDetails;